import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Spinner from "../../common/Spinner";
import { loadUserTimelineFeed } from "../../../redux/actions/userActions";
import * as apiConfig from "../../../api/config";

function ProfileTimeline({
    user,
    timeline,
    loadUserTimelineFeed
}) {

    const [processing, setProcessing] = useState(true);

    useEffect(() => {
        if (!timeline.results || timeline.results.length == 0) {
            setProcessing(true);
            loadUserTimelineFeed({ userId: user.id, pageNumber: 1, numberOfResults: 10 })
                .then(() => {
                    setProcessing(false);
                })
        } else {
            setProcessing(false);
        }
    }, []);

    return (
        processing ?
            <Spinner /> :
        (
            <React.Fragment>
                <ul className="activity-timeline">
                    {
                        timeline.results.map((item, index) => {
                            return (
                                <li key={item.activityId} className="item-frame activity">
                                    <a href={`/routes/${item.routeId}`}>
                                        <img className="activity-user" alt={item.subjectUserName} src={`${apiConfig.API_URL}user/avatar/${item.subjectUserId}.png`} />
                                        <div className="activity-details"><span className="activity-date">{item.submitted}</span>
                                            {
                                                item.activityName == "Comment" && item.subjectUserId == user.id ?
                                                    <React.Fragment>
                                                        <span className="activity-description">
                                                            You commented on your route: <p><strong>{item.routeName}</strong></p>
                                                        </span>
                                                        <span className="activity-comment">
                                                            '{item.activityDetail}'
                                                        </span>
                                                    </React.Fragment>
                                                    : ""
                                            }
                                            {
                                                item.activityName == "Comment" && item.subjectUserId != user.id ?
                                                    <React.Fragment>
                                                        <span className="activity-description">
                                                            <strong>{item.subjectUserName}</strong> commented on your route: <p><strong>{item.routeName}</strong></p>
                                                        </span>
                                                        <span className="activity-comment">
                                                            '{item.activityDetail}'
                                                        </span>
                                                    </React.Fragment>
                                                    : ""
                                            }
                                            {
                                                item.activityName == "Upload" ?
                                                    <React.Fragment>
                                                        <span className="activity-description">
                                                            You uploaded a route: <p><strong>{item.routeName}</strong></p>
                                                        </span>
                                                        <div className="activity-route-preview-frame">
                                                            <img className="activity-route-preview" alt={item.routeName} src={`${apiConfig.API_URL}routes/routepreview/${item.routeId}.png`} />
                                                        </div>
                                                    </React.Fragment>
                                                    : ""
                                            }
                                            {
                                                item.activityName == "FollowerUpload" ?
                                                    <React.Fragment>
                                                        <span className="activity-description">
                                                            <strong>{item.subjectUserName}</strong> uploaded a route: <p><strong>{item.routeName}</strong></p>
                                                        </span>
                                                        <div className="activity-route-preview-frame">
                                                            <img className="activity-route-preview" alt={item.routeName} src={`${apiConfig.API_URL}routes/routepreview/${item.routeId}.png`} />
                                                        </div>
                                                    </React.Fragment>
                                                    : ""
                                            }
                                        </div>
                                    </a>
                                </li>
                            )
                        })
                    }
                </ul>
            </React.Fragment>
        )
      
               

    );


}

ProfileTimeline.propTypes = {
    user: PropTypes.object.isRequired,
    timeline: PropTypes.object.isRequired,
    loadUserTimelineFeed: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user,
        timeline: state.timeline
    };
}

const mapDispatchToProps = {
    loadUserTimelineFeed
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileTimeline); 


// WEBPACK FOOTER //
// ./src/components/user/profile/ProfileTimeline.js